import {GET, POST} from "@/services/gateway";

const list = ({pagination, search, filter}) => {
  return POST('seat/team/list', {pagination, search, filter})
}

const getStatus = () => {
  return GET('seat/team/status')
}

const refresh = () => {
  return GET('seat/team/refresh')
}

const backupAll = () => {
  return GET('seat/team/backup')
}

const backupAllActiveSeats = () => {
  return GET('seat/team/backup/active-seats')
}

const protectAll = () => {
  return POST('seat/team/protect');
}


const unprotectAll = () => {
  return POST('seat/team/unprotect');
}

const changeStatus = ({status, id}) => {
  return POST('seat/teamstatus/change', {status, id});
}

const exportSnapshot = (filter, search, pagination) => {
  const currentDate = new Date();

  return POST('seat/team/export', {filter, search, pagination, TimeZoneOffset: currentDate.getTimezoneOffset()})
}

export {
  list,
  refresh,
  getStatus,
  protectAll,
  unprotectAll,
  backupAllActiveSeats,
  backupAll,
  changeStatus,
  exportSnapshot,
}
